<template>
  <div class="mainContainer">
    <div style="width: 100%; margin-top: 0px !important" class="loginContainer">
      <div style="width: 50%; float: left; background: #f5f2f4; padding: 8%" class="login-form-section">
        <!-- Theme Toggle positioned at top right -->
        <div style="position: absolute; top: 20px; right: 20px; z-index: 1000;">
          <ThemeToggle />
        </div>
        
        <form @submit.prevent="validate">
          <div style="display: flex">
            <div>
              <img :src="currentLogo" />
            </div>
          </div>
          <hr style="border: 1px solid #e9e6e8; margin-top: 25px" />
          <p style="font-size: 16px; color: #2f394e" class="login-title">تسجيل الدخول</p>
          <p
            style="
              font-weight: bold;
              line-height: 50%;
              font-size: 24px;
              margin-bottom: 37px;
            "
            class="welcome-text"
          >
            اهلا بك مجددا
          </p>
          <p
            style="margin-top: 30px; margin-bottom: 22px; font-size: 15px; color: #2f394e"
            class="field-label"
          >
            اسم المستخدم
          </p>

          <v-text-field
            placeholder="الاسم كامل"
            solo
            v-model="username"
            name="username"
            class="login-input"
          ></v-text-field>
          <span class="username-err">{{ errors.username }}</span>

          <p style="font-size: 15px; margin-bottom: 22px; color: #2f394e" class="field-label">كلمة المرور</p>
          <div>
            <v-text-field
              placeholder="كلمة المرور"
              solo
              name="password"
              v-model="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              class="login-input"
            ></v-text-field>
          </div>
          <span class="username-err">{{ errors.password }}</span>

          <v-btn
            class="ma-2 login-btn"
            style="
              background: #622663 !important;
              width: 100%;
              margin: 0px !important;
              height: 50px;
            "
          
            :loading="loginLoad"
            type="submit"
          >
            تسجيل الدخول
            <v-icon left style="margin-right: 10px; margin-top: 5px">
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </form>
      </div>
      <div
        style="
          margin-left: 50%;
          height: 745px;
          background: #5c315d;
          display: flex;
          justify-content: center;
          align-items: center;
        "
        class="login-image-section"
      >
        <div class="bg-image img5"></div>
        <img src="@/assets/loginPhoto.svg" style="position: absolute" />
      </div>
    </div>

    <div class="screenMobileMedia">
      <div
        style="
          display: flex;
          width: 100vw;
          height: 285px;
          background-image: linear-gradient(#451546, #814f82);
          position: relative;
          justify-content: center;
        "
        class="mobile-header"
      >
        <!-- Theme Toggle for mobile -->
        <div style="position: absolute; top: 20px; right: 20px; z-index: 1000;">
          <ThemeToggle />
        </div>
        
        <div class="bg-image img4"></div>
        <div style="position: absolute; top: 10%">
          <img :src="currentMobileLogo" />
        </div>
        <div style="position: absolute; top: 30%">
          <img src="@/assets/loginPhotoMobile.svg" />
        </div>
      </div>

      <div style="background: white; border: 1px solid #f0f0f0; padding: 5%" class="mobile-form-section">
        <form @submit.prevent="validate">
          <p style="font-size: 16px; color: #2f394e" class="login-title">تسجيل الدخول</p>
          <p
            style="
              font-weight: bold;
              line-height: 50%;
              font-size: 24px;
              margin-bottom: 37px;
            "
            class="welcome-text"
          >
            اهلا بك مجددا
          </p>
          <p
            style="margin-top: 50px; margin-bottom: 22px; font-size: 15px; color: #2f394e"
            class="field-label"
          >
            اسم المستخدم
          </p>

          <v-text-field
            placeholder="الاسم كامل"
            solo
            v-model="username"
            name="username"
            class="login-input"
          ></v-text-field>
          <span class="username-err">{{ errors.username }}</span>

          <p style="font-size: 15px; margin-bottom: 22px; color: #2f394e" class="field-label">كلمة المرور</p>
          <div>
            <v-text-field
              placeholder="كلمة المرور"
              solo
              name="password"
              v-model="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              class="login-input"
            ></v-text-field>
          </div>
          <span class="username-err">{{ errors.password }}</span>

          <v-btn
            class="ma-2 login-btn"
            style="
              background-image: linear-gradient(to right, #6d2e6e, #421143);
              width: 100%;
              margin-top: 12px !important;
              margin: 0px !important;
              height: 50px;
            "
            dark
            :loading="loginLoad"
            type="submit"
          >
            تسجيل الدخول
            <v-icon dark left style="margin-right: 10px; margin-top: 5px">
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import ThemeToggle from "@/components/Base/ThemeToggle.vue";
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ThemeToggle,
  },
  data() {
    return {
      username: "",
      password: "",
      loginLoad: false,
      errors: {
        username: "",
        password: "",
      },
      show1: false,
    };
  },
  computed: {
    ...mapGetters(['isDark']),
    currentLogo() {
      return this.isDark 
        ? require("@/assets/layer_white_converted.svg")
        : require("@/assets/Layer 2.svg");
    },
    currentMobileLogo() {
      return this.isDark 
        ? require("@/assets/layer_white_converted.svg")
        : require("@/assets/LayerMobile.svg");
    },
  },
  mounted() {
    // Initialize theme on component mount
    this.initializeTheme();
  },
  methods: {
    ...mapActions(['initializeTheme']),
    async submitSignin(uname, pass) {
      this.loginLoad = true;
      this.errors.password = "";
      const data = {
        username: uname,
        password: pass,
      };
      await Axios.post(
        `${this.$store.state.url}/agent/login`,
        data,
        {
          headers: {
            "x-api-key":
              "WFKvB4Vjr8v5BVmxY7CDQ6ZMAU8DSHSBFKCMVpkfd5hhZyKTvnV3uh5XwxSwhnfeUbptZ7Z4XFJCR4vKXeHWGHTZ6djsYXjdAatf",
          },
        }
      )
        .then((res) => {
          const payload = res.data.payload;

          let expireTime = new Date();
          expireTime.setTime(expireTime.getTime() + 12 * 60 * 60 * 1000);
          const expiresString = `expires=${expireTime.toUTCString()}`;

          // URL-encode the JSON value so Arabic names / special characters
          // don't break the cookie format on iOS Safari. Omit explicit
          // `domain=` (host-only is more reliable on Safari) and add
          // SameSite/Secure attributes that Safari requires.
          const cookieValue = encodeURIComponent(JSON.stringify(payload));
          const isHttps = window.location.protocol === "https:";
          document.cookie = `wsataJwt=${cookieValue}; ${expiresString}; path=/; SameSite=Lax${isHttps ? "; Secure" : ""}`;

          this.errors.password = "";
          localStorage.setItem("avatar", payload.avatar);
          localStorage.setItem("loggedIn_user_name", payload.agent_name);
          localStorage.setItem("hidden_baskets", JSON.stringify(payload.hidden_baskets));

          localStorage.setItem("role", payload.role);
          localStorage.setItem("is_customer_service", payload.is_customer_service);
          localStorage.setItem("account_type", payload.accountant_type);
          localStorage.setItem("id", payload.agent_id);
          localStorage.setItem("is_developer", payload.is_developer ? "1" : "0");
          if (payload.role === 7) {
            localStorage.setItem("isAdmin", true);
            localStorage.setItem("token", payload);
          } else {
            localStorage.removeItem("isAdmin");
          }

          return payload;
        })
        .then((payload) => {
          document.querySelectorAll("header").forEach((head) => {
            head.style.display = "block";
          });

          this.$store.state.loggedIn = true;

          // Single hard navigation — avoids the iOS Safari race between
          // window.location.reload() and $router.push() that landed users
          // on a white page.
          const target = this.getRoleRedirect(payload);
          window.location.href = target;
        })
        .catch(() => {
          this.errors.password = "الحساب غير متوفر ";
          this.loginLoad = false;
        });
    },
    getRoleRedirect(payload) {
      const role = Number(payload.role);
      const isCustomerService = Number(payload.is_customer_service) === 1;
      const accountType = Number(payload.accountant_type);

      if (role === 1) return "/salesManager";
      if (role === 0 && isCustomerService) return "/customer-service/requests/all";
      if (role === 0) return "/agent/requests/all";
      if (role === 7) return "/admin";
      if (role === 16) return "/customer-service-supervisor";
      if (role === 5) return "/quality/requests/all";
      if (role === 2) return "/funding-manager";
      if (role === 8) return accountType === 0 ? "/accounting/tsaheelreports" : "/accounting/wasatareports";
      return "/";
    },
    async validate() {
      document.forms[0].username.style.border = "none";
      document.forms[0].password.style.border = "none";
      this.errors.username = "";
      this.errors.password = "";
      if (!this.username) {
        this.errors.username = "الحقل مطلوب";
      } else if (!this.password) {
        this.errors.password = "الحقل مطلوب";
      } else {
        await this.submitSignin(this.username, this.password);
      }
    },
  },
};
</script>

<style>
@media only screen and (max-width: 1114px) {
  .mainContainer {
    overflow: hidden;
  }

  .loginContainer {
    display: none;
  }

  .screenMobileMedia {
    display: block;
  }
}

@media only screen and (min-width: 1114px) {
  .loginContainer {
    display: block;
  }

  .screenMobileMedia {
    display: none;
  }
}

.mainContainer__userNameInput {
  background-color: red;
}
.username-err {
  color: darkred;
  font-size: 12px;
  font-weight: 700;
  text-align: end;
  display: block;
  margin-bottom: 20px;
  margin-top: -20px;
}

.loginContainer .v-input__slot {
  border: 1px solid #e7e6e7 !important;
  height: 55px;
  /* padding-right: 1px !important; */
}

.screenMobileMedia .v-input__slot {
  border: 2px solid #ecedec !important;
  height: 55px;
  /* padding-right: 1px !important; */
}

.loginContainer .v-text-field.v-text-field--solo ::placeholder,
.screenMobileMedia .v-text-field.v-text-field--solo ::placeholder {
  font-size: 14px;
  font-weight: bold;
  color: #2f394e;
  padding-right: 10px;
}

.loginContainer .v-icon.v-icon.v-icon--link,
.screenMobileMedia .v-icon.v-icon.v-icon--link {
  color: #926b93 !important;
  margin-bottom: 20px;
}

.loginContainer .v-input__icon,
.screenMobileMedia .v-input__icon {
  visibility: visible !important;
}

.container {
  margin-top: 0px !important;
}

.loginContainer .v-btn__content,
.screenMobileMedia .v-btn__content {
  font-weight: bold;
  font-size: 16px;
}

.loginContainer .content-container,
.screenMobileMedia .content-container {
  margin-top: 0px !important;
}

.loginContainer,
.screenMobileMedia {
  font-family: DIN Next LT Arabic;
}

.bg-image {
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.img5 {
  background-image: url("../../assets/scrollGroup.png");
  width: 100%;
}

.img4 {
  background-image: url("../../assets/scrollGroubMobile.png");
  width: 100%;
}.dark .mainContainer {
    min-height: 100vh !important;
    background: #23272e  !important;
}
</style>
